import { useState } from "react";
import { ShieldCheck, CaretDown, Check } from "@phosphor-icons/react";

const POINTS = [
  <>Everything happens in your browser — photos are <strong>never sent to our servers or to the AI</strong>.</>,
  <>Large images are <strong>compressed</strong> and <strong>location &amp; other metadata are removed</strong> before they go into the PDF.</>,
  <>The finished photo Ebook is <strong>not saved in your account</strong> — you download and keep it yourself.</>,
  <>Make a revised Ebook later? It's free — you'll simply choose your photos again.</>,
  <>If a device can't do this privately, we'll say so and let you continue without photos — we never upload them as a workaround.</>,
];

export function PhotoPrivacyPanel() {
  const [open, setOpen] = useState(false);
  return (
    <section data-testid="privacy-panel" className="rounded-2xl border border-[#2E6B4F]/20 bg-[#EAF2EC] p-5">
      <div className="flex items-start gap-3">
        <ShieldCheck size={24} weight="fill" className="mt-0.5 shrink-0 text-[#2E6B4F]" />
        <div className="flex-1">
          <h2 className="text-base font-semibold text-[#1f4a37]">Your photos stay on this device</h2>
          <p className="mt-1 text-sm text-[#2f4a3e]">
            Photos are placed into your Ebook PDF inside your browser. They are never uploaded, stored or shared,
            and we never create public photo links.
          </p>
          <button type="button" data-testid="how-private-toggle" onClick={() => setOpen((o) => !o)} className="mt-2 inline-flex items-center gap-1 text-sm font-medium text-[#1f4a37] underline-offset-2 hover:underline">
            How your photos stay private
            <CaretDown size={14} className={open ? "rotate-180 transition-transform" : "transition-transform"} />
          </button>
          {open && (
            <ul data-testid="how-private-details" className="mt-3 space-y-2 text-sm text-[#2f4a3e]">
              {POINTS.map((p, i) => (
                <li key={i} className="flex gap-2"><Check size={16} weight="bold" className="mt-0.5 shrink-0 text-[#2E6B4F]" /> <span>{p}</span></li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </section>
  );
}
